var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('collapse',{attrs:{"collapsable":false}},[_c('legacy-invoice-provider',{attrs:{"invoice-id":_vm.invoiceId}},[_c('legacy-invoice-details')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }